module.exports = __webpack_public_path__ + "img/1f_r_twodays.e9ca5ac7.png";